import React from "react";
import ErrorBoundary from "../../hoc/errorBoundary/error.js";
import Item from "../../components/chemicals/item";
import classes from "./chemicals.module.scss";
import { shallowEqual, useSelector, useDispatch } from "react-redux";

function Chemicals(props) {
  const chemicals = useSelector((state) => state.chemicals, shallowEqual);

  return (
    <ErrorBoundary>
      <div className={classes.wrapper}>
        <ul className={classes.list}>
          {Object.keys(chemicals).map((el) => {
            return (
              <Item
                title={el}
                srcImg={chemicals[el].srcImg}
                description={chemicals[el].description}
                maxAmount={chemicals[el].maxAmount}
                danger={chemicals[el].danger}
                dangerType={chemicals[el].dangerType}
              />
            );
          })}
        </ul>
      </div>
    </ErrorBoundary>
  );
}

export default Chemicals;
